import { IActivityInvoiceConfigBase } from '../../models/activities';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface IUpdateActivityInvoiceConfigRequest {
  activityId: string;
  bookingCostCenter?: string;
  bookingProductCode?: string;
  bookingProductType?: string;
  bookingProductNature?: string;
  bookingInvoiceType: 'NF' | 'ND';
  guestBookingCostCenter?: string;
  guestBookingProductCode?: string;
  guestBookingProductType?: string;
  guestBookingProductNature?: string;
  guestBookingInvoiceType: 'NF' | 'ND';
}

export type IUpdateActivityInvoiceConfigResponse = IActivityInvoiceConfigBase;

export const updateActivityInvoiceConfigsService = async ({
  activityId,
  bookingCostCenter,
  bookingProductCode,
  bookingProductType,
  bookingProductNature,
  bookingInvoiceType,
  guestBookingCostCenter,
  guestBookingProductCode,
  guestBookingProductType,
  guestBookingProductNature,
  guestBookingInvoiceType,
}: IUpdateActivityInvoiceConfigRequest): Promise<IUpdateActivityInvoiceConfigResponse> => {
  const { data } =
    await jhsfBookingsApi.put<IUpdateActivityInvoiceConfigResponse>(
      `/activities/${activityId}/invoice-configs`,
      {
        bookingCostCenter,
        bookingProductCode,
        bookingProductType,
        bookingProductNature,
        bookingInvoiceType,
        guestBookingCostCenter,
        guestBookingProductCode,
        guestBookingProductType,
        guestBookingProductNature,
        guestBookingInvoiceType,
      },
    );

  return data;
};
